import React, { Fragment, useState } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { PostEdit, Post, Discard } from '../../Constant';
import { Breadcrumbs, Btn } from '../../AbstractElements';
import FormPost from './BlogPost/FormPost';
import HeadingCommon from "../../Common/Component/HeadingCommon";
import axios from 'axios';

const BlogPostContain = () => {
  const [formData, setFormData] = useState({
    tenant_id: '',
    image: '',
    blog_date: '',
    title: '',
    content: '',
    user_name: '',
    type: 'Audio', // Default value for the radio button group
    category: [],  // Array to hold multiple categories
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleCategoryChange = (selected) => {
    setFormData({
      ...formData,
      category: selected.map(item => item.name),
    });
  };

  const handleEditorChange = (evt) => {
    const content = evt.editor.getData();
    setFormData({
      ...formData,
      content,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('/blog/create', formData);
      console.log('Blog created successfully', response.data);
      // Optionally reset the form after successful submission
      setFormData({
        tenant_id: '',
        image: '',
        blog_date: '',
        title: '',
        content: '',
        user_name: '',
        type: 'Audio',
        category: [],
      });
    } catch (error) {
      console.error('Error creating blog:', error);
    }
  };

  return (
    <Fragment>
      <Breadcrumbs mainTitle="Add Post" parent="Blog" title="Add Post" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <HeadingCommon CardHeaderClassName="pb-0" Heading={PostEdit} />
              <CardBody className="add-post">
                <FormPost
                  handleInputChange={handleInputChange}
                  formData={formData}
                  handleCategoryChange={handleCategoryChange}
                  handleEditorChange={handleEditorChange}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default BlogPostContain;
